export const COMPARE_COUNT_KEY = "compareCount";
export const COMPARE_OFFERS_KEY = "compareOffers";